module.exports = __webpack_public_path__ + "static/media/nft.3206d98f.png";